export default {
    methods: {
        goAccount(e, account, id) {
            e.stopPropagation();
            this.$router.push(`/account/${account}/${id}`);
        }
    }
}